export default __webpack_public_path__ + "static/media/logo.3cc0528b.svg";